import { TextField } from "@mui/material";
import { useState, forwardRef } from "react";
import { IMaskInput } from "react-imask";

const PhoneMaskInput = forwardRef(function PhoneMaskInput(props, ref) {
  const { onChange, mask, value, ...other } = props;
  return (
    <IMaskInput
      {...other}
      value={String(value || '')}
      mask={mask}
      inputRef={ref}
      definitions={{
        "#": /[0-9]/,
      }}
      onAccept={(value) => onChange({ target: { name: other.name, value } })}
      overwrite
    />
  );
});

export const FormPhoneInput = ({
  value,
  handleChange,
  disabled,
  name = "phone",
  label = "Telefon Numarası *",
  size = "",
  sx,
  error: externalError,
  helperText: externalHelperText,
}) => {
  const [error, setError] = useState(false);

  const handleInputChange = (e) => {
    // Önce temizle - başta 0 varsa kaldır
    let cleanedValue = String(e.target.value || '').replace(/\D/g, "");
    
    // Başta 0 varsa kaldır
    if (cleanedValue.startsWith("0")) {
      cleanedValue = cleanedValue.substring(1);
    }
    
    // Temizlenmiş değerle yeni event oluştur
    const newEvent = {
      ...e,
      target: {
        ...e.target,
        value: String(cleanedValue),
        name: name
      }
    };
    
    handleChange(newEvent); // Temizlenmiş değerle handleChange'i çağır

    // Validasyon - 10 haneli telefon numarası, 5 ile başlamalı
    // Eğer numara girilmişse ve 5 ile başlamıyorsa hata ver
    if (cleanedValue.length > 0 && !cleanedValue.startsWith("5")) {
      setError(true);
    } else if (cleanedValue.length === 10 && cleanedValue.startsWith("5")) {
      setError(false);
    } else if (cleanedValue.length > 0 && cleanedValue.length < 10) {
      setError(false); // Yazarken hata gösterme
    } else {
      setError(false);
    }
  };

  const handleBlur = (e) => {
    const cleanedValue = e.target.value.replace(/\D/g, "");
    
    // Blur'da tam validasyon yap
    if (cleanedValue.length > 0) {
      const isValidNumber = cleanedValue.length === 10 && cleanedValue.startsWith("5");
      setError(!isValidNumber);
    }
  };

  return (
    <TextField
      fullWidth
      name={name}
      label={label}
      value={value || ''}
      onChange={handleInputChange}
      onBlur={handleBlur}
      error={error || externalError}
      helperText={error ? "Geçersiz telefon numarası" : externalHelperText || ""}
      variant="outlined"
      disabled={disabled}
      size={size}
      slotProps={{
        input: {
          inputComponent: PhoneMaskInput,
          inputProps: {
            mask: "(###) ### ## ##",
            name: name,
          },
        },
      }}
      sx={{
        ...sx,
        "& .MuiInputBase-input": {
          fontSize: "14px",
        },
        "& .MuiFormHelperText-root": {
          fontSize: {
            xs: "9px",
            sm: "12px",
          },
        },
      }}
    />
  );
};

